import { Role } from 'features/SharedTimeclock/slice';
export const SHARED_TIMECLOCK_SLICE = 'sharedTimeClock' as const;
export const MAX_PIN_LENGTH = 6;

export const NO_ROLE: Role = {
  id: -1,
  name: 'unassigned',
};

export const FAKE_PIN_DATA = {
  roles: [
    {
      id: 42631,
      name: 'Owner',
    },
  ],
  type: 'shifts',
  shifts: [
    {
      id: 8207728,
      color: 'blue',
      unscheduled: false,
      owner_id: 1213175,
      owner_type: 'Job',
      start_at: '10/27/2025 09:00',
      end_at: '10/27/2025 12:30',
      role_name: 'Owner',
    },
    {
      id: 8207729,
      color: 'blue',
      unscheduled: false,
      owner_id: 1213175,
      owner_type: 'Job',
      start_at: '10/27/2025 14:00',
      end_at: '10/27/2025 17:00',
      role_name: 'Owner',
    },
    {
      id: 8207730,
      color: 'blue',
      unscheduled: false,
      owner_id: 1213175,
      owner_type: 'Job',
      start_at: '10/27/2025 18:00',
      end_at: '10/27/2025 23:30',
      role_name: 'Owner',
    },
  ],
  mandated_breaks: [
    {
      id: 35082,
      duration: 30,
      paid: false,
    },
    {
      id: 35081,
      duration: 10,
      paid: true,
    },
  ],
  job: {
    id: 1213175,
    user_name: 'Andrew Jain',
    managerial: true,
  },
  prevent_early_clock_in: false,
  current_mandated_break: null,
};

export const SHORT_TIME_SLOTS = [
  '7am',
  '8am',
  '9am',
  '10am',
  '11am',
  '12pm',
  '1pm',
  '2pm',
  '3pm',
  '4pm',
  '5pm',
  '6pm',
  '7pm',
  '8pm',
];

export const FAKE_API = {
  date: '2025-10-29',
  location: {
    id: 11,
    name: 'Payroll Demo - 6f33',
    time_zone: 'America/Los_Angeles',
  },
  shifts: [
    {
      id: 640,
      start_at: '2025-11-04T08:30:00-08:00',
      end_at: '2025-11-04T17:00:00-08:00',
      unscheduled: false,
      rating: null,
      feedback: null,
      user: {
        id: 59,
        name: 'Hillary Ramsey',
        avatar_url: 'https://cdn.joinhomebase.com/avatars/hr_medium.png',
      },
      role: {
        id: 18,
        name: 'Cook',
      },
      timecard: null,
      status: 'unstarted',
      can_edit: true,
    },
    {
      id: 637,
      start_at: '2025-11-04T09:00:00-08:00',
      end_at: '2025-11-04T16:15:00-08:00',
      unscheduled: false,
      rating: null,
      feedback: null,
      user: {
        id: 63,
        name: 'Ana Carney',
        avatar_url: 'https://cdn.joinhomebase.com/avatars/ac_medium.png',
      },
      role: {
        id: 17,
        name: 'Server',
      },
      timecard: null,
      status: 'unstarted',
      can_edit: true,
    },
    {
      id: 636,
      start_at: '2025-11-04T09:00:00-08:00',
      end_at: '2025-11-04T16:30:00-08:00',
      unscheduled: false,
      rating: null,
      feedback: null,
      user: {
        id: 57,
        name: 'Andrew Jain',
        avatar_url: 'https://cdn.joinhomebase.com/avatars/aj_medium.png',
      },
      role: {
        id: 20,
        name: 'Owner',
      },
      timecard: null,
      status: 'unstarted',
      can_edit: true,
    },
    {
      id: 638,
      start_at: '2025-11-04T09:45:00-08:00',
      end_at: '2025-11-04T16:45:00-08:00',
      unscheduled: false,
      rating: null,
      feedback: null,
      user: {
        id: 69,
        name: 'Chris Gad',
        avatar_url: 'https://cdn.joinhomebase.com/avatars/cg_medium.png',
      },
      role: {
        id: 21,
        name: 'Manager',
      },
      timecard: null,
      status: 'unstarted',
      can_edit: true,
    },
    {
      id: 639,
      start_at: '2025-11-04T09:15:00-08:00',
      end_at: '2025-11-04T17:00:00-08:00',
      unscheduled: false,
      rating: null,
      feedback: null,
      user: {
        id: 71,
        name: 'Danilo Jatin',
        avatar_url: 'https://cdn.joinhomebase.com/avatars/dj_medium.png',
      },
      role: {
        id: 21,
        name: 'Manager',
      },
      timecard: null,
      status: 'unstarted',
      can_edit: true,
    },
  ],
  mandated_breaks: [
    {
      id: 19,
      duration: 10,
      paid: true,
      name: '10 minute break',
    },
    {
      id: 20,
      duration: 30,
      paid: false,
      name: '30 minute break',
    },
  ],
  config: {
    shift_feedback: true,
    shift_tips: false,
    prevent_early_clock_in: false,
    early_in_min: 5,
  },
};
